import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from 'next/head';

const MobileRestaurants = dynamic(() => import('../../components/UAEPages/restaurants/MobileRestaurants'), {
    loading: () => <Loading />

});
const DesktopRestaurants = dynamic(() => import('../../components/UAEPages/restaurants/DesktopRestaurants'), {
    loading: () => <Loading />

});


const restaurants = ({ mobileView }) => {
  return (
    <div>
      <Head>
        <title>Restaurant POS Billing Software in UAE | QueueBuster POS</title>
        <meta name="description" content="Manage billing, tables, KOT, inventory, recipes & VAT compliance with QueueBuster Restaurant POS Software in UAE. Ideal for cafés, QSRs & fine dining. Book a free demo."/>
        <link rel="canonical" href="https://queuebuster.co/ae-en/restaurant-pos-software-uae" />
        <link rel="alternate" href="https://queuebuster.co/ae-en/restaurant-pos-software-uae" hrefLang="en" />
        <meta property="og:title" content="Next-Gen Restaurant POS Billing Software for UAE Restaurants"/>
        <meta property="og:description" content="Simplify restaurant billing, table management, KDS, inventory, recipes & VAT reporting with QueueBuster POS. Trusted by restaurants across the UAE. Book your free demo today."/>
        <meta property="og:image" content="" />
        <meta property="og:url" content="https://queuebuster.co/ae-en/restaurant-pos-software-uae" />

      </Head>
        {mobileView ? <MobileRestaurants /> : <DesktopRestaurants />}
    </div>
  )
}



export default restaurants